module.exports = __webpack_public_path__ + "img/button_arrow_right_icon.6723519.svg";